<template>
   <div class="scene-btn" :class="{selected: isSelected}" v-on:click="$emit('sceneClicked', $event.target.id)"></div>
</template>

<script>
export default {
   props: {
      sceneNum: Number,
      isSelected: false
   }
}
</script>

<style lang="scss">
   .scene-btn {
      height: 60px;
      background-color: #a7a7a7;
      flex: 1;

      &:not(:last-child) {
         margin-right: 7px;
      }

      &:hover {
         cursor: pointer;
      }

      &.selected {
         background-color: $bard-gold;
      }
   }
</style>
